// extracted by mini-css-extract-plugin
export default {"root":"DraftContent_root__ysB5e"};